export default "__VITE_ASSET__92fe3047__"